import React, { createContext, useReducer } from "react";
import { cityAttractionsReducer } from "../reducers/CityAttractionsReducer";

export const CityAttractionsContext = createContext();

const CityAttractionsContextProvider = (props) => {
	const [cityAttractionsState, dispatch] = useReducer(cityAttractionsReducer, {
	
		tours : [],
		article : "",
		loading: false,
	});

	return <CityAttractionsContext.Provider value={{ cityAttractionsState, dispatch }}>{props.children}</CityAttractionsContext.Provider>;
};

export default CityAttractionsContextProvider;
